var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',[_c('v-card',{staticClass:"mx-auto",attrs:{"width":"300px","height":"225px"}},[_c('img',{staticClass:"image",attrs:{"src":_vm.getPic('Jozef_Ostyn.jpg'),"height":"225px","width":"300px"}})]),_c('div',{staticClass:"centreer"},[_c('h2',[_vm._v(" Jozef Ostyn ")]),_c('h3',[_vm._v(" VICE-GOUVERNEUR ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }